// features/podio/podioSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchPodioByTorneoCategoriaAPI,
  generatePodioDesdeTablaFinalAPI,
} from '../../services/podioService';

const initialState = {
  podio: [],      // listado de puestos
  loading: false,
  error: null,
};

// Thunk para cargar el podio de una categoría de torneo
export const fetchPodioByTorneoCategoria = createAsyncThunk(
  'podio/fetchByTorneoCategoria',
  async (idTorneoCategoria, { rejectWithValue }) => {
    try {
      return await fetchPodioByTorneoCategoriaAPI(idTorneoCategoria);
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const generatePodioDesdeTablaFinal = createAsyncThunk(
  'podio/generateDesdeTablaFinal',
  async ({ idTorneoCategoria, modo = "ajustada" }, { rejectWithValue }) => {
    try {
      return await generatePodioDesdeTablaFinalAPI(idTorneoCategoria, { modo });
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const podioSlice = createSlice({
  name: 'podio',
  initialState,
  reducers: {
    clearPodio(state) {
      state.podio = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPodioByTorneoCategoria.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPodioByTorneoCategoria.fulfilled, (state, action) => {
        state.podio = action.payload;
        state.loading = false;
      })
      .addCase(fetchPodioByTorneoCategoria.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generatePodioDesdeTablaFinal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generatePodioDesdeTablaFinal.fulfilled, (state, action) => {
        state.podio = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.podio || [];
        state.loading = false;
      })
      .addCase(generatePodioDesdeTablaFinal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearPodio } = podioSlice.actions;
export default podioSlice.reducer;
